import React from "react";
import { Field } from "react-final-form";
import { Col, Row } from "reactstrap";
import CustomDropzone from "src/components/Form/Dropzone/Dropzone";
import SimpleDatePickerField from "src/components/Form/SimpleDatePickerFieldV2/SimpleDatePickerField";
import SingleSelectField from "src/components/Form/SingleSelectFieldV2/SingleSelectField";
import TextField from "src/components/Form/TextFieldV2/TextFieldV2";
import * as S from "src/constants/StringConstants";

export const BrokerContractsForm = ({ form, formProps, selectCarrierList, selectStatusTypeList }) => {
  const values = formProps.values;

  return (
    <>
      <Row>
        <Col sm="6">
          <SingleSelectField
            name="carrierTypeID"
            label={S.BRO_CONTRACTING_CARRIER}
            options={[{ key: "", value: null }, ...selectCarrierList]}
          />
        </Col>
        <Col sm="6">
          <SingleSelectField
            name="statusTypeID"
            label={S.BRO_CONTRACTING_STATUS}
            options={[{ key: "", value: null }, ...selectStatusTypeList]}
          />
        </Col>
      </Row>
      <Row>
        <Col sm="6">
          <TextField name="licenseNumber" label={S.BRO_CONTRACTING_LICENSE} />
        </Col>
        <Col sm="6">
          <SimpleDatePickerField name="expirationDate" label={S.BRO_CONTRACTING_EXPIRATION_DATE} isFormMode />
        </Col>
      </Row>
      <Row>
        <Col>
          <TextField name="notes" label={S.BRO_CONTRACTING_NOTES} multiline />
        </Col>
      </Row>
      <Row>
        <Col>
          <label className="contracting-docs-modal__section-title">{S.BRO_CONTRACTING_ATTACH_FILE}</label>
          <Field name="file">
            {() => (
              <CustomDropzone
                files={values?.file ? [values.file] : []}
                onDrop={file => form.mutators.setValue("file", file[0])}
                onRemove={() => form.mutators.setValue("file", null)}
                multiple={false}
                placeholder={S.UDM_DROPZONE}
              />
            )}
          </Field>
        </Col>
      </Row>
    </>
  );
};
